module.exports = __webpack_public_path__ + "img/EMT-BLCA_GSE171351.b981efd1.png";